<abp-card class="zn-crud-page">
  <abp-card-body>
    <app-crud-page
      #crudPage
      [tableName]="config.localizationKey"
      [permission]="config.permission"
      [fields]="fields"
      [dataset]="dataset()"
      [loading]="loading()"
      [loadData]="loadData"
      (createRecord)="create()"
      (deleteRecord)="deleteRecords()"
      (editRow)="edit($event)"
      (saveInMemoryRequested)="onSaveInMemory($event)"
      (selectedItemsChange)="onRowSelection($event)"
      [exportInProgress]="exporting()"
      (exportToExcelRecord)="exportToExcel()"
    ></app-crud-page>
  </abp-card-body>
</abp-card>

<app-generic-form
  #genericForm
  (payload)="save($event)"
></app-generic-form>
